export const IMAGE_BORDER_STYLE = '1px solid #e7e9e8'

export const IMAGE_SHADOW_STYLE = '0 3px 6px 0 rgba(0, 0, 0, 0.15)'
